import { useEffect, useState, useRef } from 'react';
import styles from './ItemPage.module.css'

import likeBlueIcon from '../../../assets/like_blue-icon.svg';
import wishlistIcon from '../../../assets/wishlist-icon.svg';
import langIcon from '../../../assets/lang-icon.svg';

import { useGetItemByIdQuery } from '../../../store/api/item.api';
import { useGetUserWishlistQuery, useAddWishlistMutation, useDeleteWishlistItemMutation } from '../../../store/api/wishlist.api';
import { useParams } from 'react-router-dom';
import { useDbUserId } from '../../../hooks/useDbUserId';
import { sendProductDetail } from '../../../utils/yandexMetrika';

import { Header } from '../../../components/Header/Header';
import { BlueBtn } from '../../../UI/BlueBtn/BlueBtn';

export const ItemPage = () => {
	const { id } = useParams();
	const { dbUserId } = useDbUserId();
	const schema = 'PS_sharing'
	const [activeSub, setActiveSub] = useState(3);
	const hasSentDetail = useRef(false);

	const { data: item, isLoading, isError } = useGetItemByIdQuery({ itemId: id, schema });

	const { data: wishlistData, refetch } = useGetUserWishlistQuery(
			{ userId: dbUserId, schema },
			{ skip: isLoading || !dbUserId }
		);
		const [addItemToWishlist] = useAddWishlistMutation();
		const [deleteItemFromWishlist] = useDeleteWishlistItemMutation();

	const [inWishlist, setInWishlist] = useState(false);
	const [currentItemData, setCurrentItemData] = useState({price: 0, type: ''})

	useEffect(() => {
		setCurrentItemData({
			price: item?.P2_price_disc || item?.P2_price,
			type: 'P2',
		})
	}, [isLoading])

	useEffect(() => {
		if (
			item &&
			!hasSentDetail.current
		) {
			sendProductDetail(item, 'PS_sharing');
			hasSentDetail.current = true;
		}
	}, [item]);


	useEffect(() => {
			if (wishlistData?.items && id) {
				const exists = wishlistData.items.some(wishlistItem => wishlistItem.itemId === Number(id));
				setInWishlist(exists);
			}
		}, [wishlistData, id]);

	const toggleWishlist = async () => {
		if (!dbUserId) return;

		try {
			if (inWishlist) {
				await deleteItemFromWishlist({ data: { userId: dbUserId, itemId: id }, schema });
				setInWishlist(false);
			} else {
				await addItemToWishlist({ data: { userId: dbUserId, itemId: id }, schema });
				setInWishlist(true);
			}
			await refetch();
		} catch (error) {
			console.error('Ошибка при изменении wishlist:', error);
		}
	};


	if (isLoading) return <div>Загрузка...</div>;
	if (isError || !item) return <div>Произошла ошибка или товар не найден.</div>;

	return (
		<div className='main'>
			<div
				className={styles.itemImg}
				style={{
					backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.9), transparent), url(${item.img})`
				}}
			>
				<Header />
			</div>

			<div className={styles.title_block}>
				<h2>{item.title}</h2>
				<img
					src={inWishlist ? likeBlueIcon : wishlistIcon}
					alt="wishlist"
					onClick={toggleWishlist}
				/>
			</div>

			<div className={`form ${styles.typesContainer}`}>
				{
					item.P3_PS5_price &&
					<div
						className={`${styles.type} ${activeSub === 1 ? styles.activeSub : ''}`}
						onClick={() => {
							setCurrentItemData({
								price: item.P3_PS5_price_disc || item.P3_PS5_price,
								type: 'P3_PS5'
							})
							setActiveSub(1)
						}}
					>
						<p className={styles.typeTitle}>П3 PS5</p>
						<p style={!item.P3_PS5_price_disc ? { color: '#FFFFFF' } : {}} className={styles.typePrice}>{item.P3_PS5_price_disc || item.P3_PS5_price} ₽</p>
					</div>
				}
				{
					item.P3_PS4_price &&
					<div
						className={`${styles.type} ${activeSub === 2 ? styles.activeSub : ''}`}
						onClick={() => {
							setCurrentItemData({
								price: item.P3_PS4_price_disc || item.P3_PS4_price,
								type: 'P3_PS4'
							})
							setActiveSub(2)
						}}
					>
						<p className={styles.typeTitle}>П3 PS4</p>
						<p style={!item.P3_PS4_price_disc ? { color: '#FFFFFF' } : {}} className={styles.typePrice}>{item.P3_PS4_price_disc || item.P3_PS4_price} ₽</p>
					</div>
				}
				{
					item.P2_price &&
					<div
						className={`${styles.type} ${activeSub === 3 ? styles.activeSub : ''}`}
						onClick={() => {
							setCurrentItemData({
								price: item.P2_price_disc || item.P2_price,
								type: 'P2'
							})
							setActiveSub(3)
						}}
					>
						<p className={styles.typeTitle}>П2</p>
						<p style={!item.P2_price_disc ? { color: '#FFFFFF' } : {}} className={styles.typePrice}>{item.P2_price_disc || item.P2_price} ₽</p>
					</div>
				}
				
			</div>

			<div className={`form`}>
				<p>Информация</p>
				<ul className={styles.infoList}>
					<li>
						<div className={'bluePoint'}></div>
						<p>П3 - вы играете с личного аккуанта</p>
					</li>
					<li>
						<div className={'bluePoint'}></div>
						<p>П2 - вы играете с выданного аккаунта</p>
					</li>
					<li>
						<div className={'bluePoint'}></div>
						<p>После оплаты вы получите доступ к
							аккаунту и необходимые инструкции</p>
					</li>
					<li>
						<div className={'bluePoint'}></div>
						<p>Данные аккаунта менять запрещено</p>
					</li>
				</ul>
			</div>
			
			<div className={`form ${styles.langBlock}`}>
				<img src={langIcon} alt="lang" />
				<div>
					<p>Локализация</p>
					<p>{item.lang}</p>
				</div>
			</div>

			<div className={styles.priceBlock}>
				<h2>{currentItemData.price} ₽</h2>
				<div style={{width: "75%"}}>
					<BlueBtn
						type='inSharingItem'
						text="Купить"
						itemId={item.id}
						itemType={currentItemData.type}
					/>
				</div>
			</div>
		</div>
	);
};
